import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavAppsFill = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#2D2E2E"
      d="M11 3H3v8h8V3ZM11 13H3v8h8v-8ZM21 13h-8v8h8v-8ZM18 6V3h-2v3h-3v2h3v3h2V8h3V6h-3Z"
    />
  </svg>
);
export default SvgNavAppsFill;
